import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { STORELOCATORCOMPONENT } from '../components/storelocator.component';
import { MULTIPLELOCATIONSSERVICE } from './multiple.locations.service';
import { TEMPLATE } from '../templates/cwc-templates';
import { MARKER } from './google.marker.service';

export class FilterService {
  /**
   * Propertys
   */
  filterHTMLElement: HTMLElement;
  storeFoundHTMLElemnt: HTMLElement;
  filterElems: NodeListOf<Element>;
  filtersAll = [];

  createLocationsFilter() {
    const filterElement = MULTIPLELOCATIONSSERVICE.sidebarHeader.querySelector<HTMLElement>('cwc-filter');
    const filter = filterElement ? filterElement : document.createElement('cwc-filter');

    filter.innerHTML = TEMPLATE.getFilterTemplate();
    this.filterHTMLElement = filter;
    MULTIPLELOCATIONSSERVICE.sidebarHeader.appendChild(filter);
    MULTIPLELOCATIONSSERVICE.handleAccordion(filter);
    this.handleLocationsFilter(MULTIPLELOCATIONSSERVICE.sidebarBody);
  }

  handleLocationsFilter(sidebarBody: HTMLElement) {
    const filterElems = this.filterHTMLElement.querySelectorAll('input[type="checkbox"], form');
    const storeFoundHTMLElemnt = this.filterHTMLElement.querySelector('#info-stores-found') as HTMLElement;

    const storesFoundText =
      sidebarBody.childNodes.length > 1
        ? TextResources.resources['filter'].stores_found
        : TextResources.resources['filter'].store_found;
    storeFoundHTMLElemnt.innerHTML =
      sidebarBody.childNodes.length > 0
        ? sidebarBody.childNodes.length + ' ' + storesFoundText
        : TextResources.resources['filter'].not_found;

    this.storeFoundHTMLElemnt = storeFoundHTMLElemnt;
    this.filterElems = filterElems;

    for (let i = 0; i < filterElems.length; i++) {
      const itemId = filterElems[i].id;

      filterElems[i].addEventListener('click', (e) => {
        this.checkFilter(e, sidebarBody);
      });

      if (ConfigData.data['prefilter'] === itemId) {
        const filterItem = filterElems[i] as HTMLElement;

        this.setPrefilter(filterItem);
      }
    }
  }

  setPrefilter(filterItem) {
    if (ConfigData.data['filterListOpened']) {
      const filterList = this.filterHTMLElement.querySelector('.accordion') as HTMLElement;
      filterList.click();
    }
    filterItem.click();
    // MARKER.handleMarkers(currentLocations);
  }

  checkFilter(event, locations) {
    if (event.target.checked) {
      this.filtersAll[event.target.id] = event.target.id;
    } else {
      delete this.filtersAll[event.target.id];
    }

    const filters = Object.values(this.filtersAll);

    this.resetButtonEvent();

    let countHiddenStores = 0;
    let countDisplayedStores = 0;

    locations.childNodes.forEach((location) => {
      if (location.id !== 'no-store-found') {
        let storesFoundText = '';

        if (filters.length === 0) {
          location.setAttribute('class', '');
          storesFoundText =
            locations.childNodes.length > 1
              ? TextResources.resources['filter'].stores_found
              : TextResources.resources['filter'].store_found;
          this.storeFoundHTMLElemnt.innerHTML =
            locations.childNodes.length > 0
              ? locations.childNodes.length + ' ' + storesFoundText
              : TextResources.resources['filter'].not_found;
          MARKER.handleMarker('showAll', null);
        } else {
          let found = false;
          const prodSet = {
            'prod-photos-strip': location.querySelector('#prod-photos-strip').textContent,
            'prod-greeting-cards': location.querySelector('#prod-greeting-cards').textContent,
            'prod-collages': location.querySelector('#prod-collages').textContent,
            'prod-photo-sets': location.querySelector('#prod-photo-sets').textContent,
            'prod-multipart-photos': location.querySelector('#prod-multipart-photos').textContent,
            'prod-retro-minis': location.querySelector('#prod-retro-minis').textContent,
            'prod-stickers': location.querySelector('#prod-stickers').textContent,
            'prod-product-labels': location.querySelector('#prod-product-labels').textContent,
            'prod-photos': location.querySelector('#prod-photos').textContent,
            'prod-photos-frame': location.querySelector('#prod-photos-frame').textContent,
            'prod-poster': location.querySelector('#prod-poster').textContent,
            'prod-canvas': location.querySelector('#prod-canvas').textContent,
            'prod-passfoto': location.querySelector('#prod-passfoto').textContent,
          };

          filters.forEach(() => {
            const countYes = [];

            for (let i = 0; i < filters.length; i++) {
              const element = filters[i];
              const elemExist = prodSet[element];

              if (elemExist === 'yes') {
                countYes.push(element);
              }
            }

            if (countYes.length > 0 && countYes.length === filters.length) {
              found = true;
              return;
            }
          });

          if (found) {
            location.setAttribute('class', '');
            location.classList.add('show');
            countDisplayedStores = countDisplayedStores + 1;
            if (ConfigData.data['prefilter']) {
              MARKER.prefilterItems.push(location.id);
            }
            MARKER.handleMarker('show', location.id);
          } else {
            location.setAttribute('class', '');
            location.classList.add('hide');
            countHiddenStores = countHiddenStores + 1;
            MARKER.handleMarker('hide', location.id);
          }

          storesFoundText =
            countDisplayedStores > 1
              ? TextResources.resources['filter'].stores_found
              : TextResources.resources['filter'].store_found;
          this.storeFoundHTMLElemnt.innerHTML =
            countDisplayedStores > 0
              ? countDisplayedStores + ' ' + storesFoundText
              : TextResources.resources['filter'].not_found;
        }
      }
    });
    const allStoresHidden = countHiddenStores === locations.childElementCount ? true : false;
    this.displayNoStoreFound(allStoresHidden);
  }

  /**
   * If all stores hidden, display "No store found for your search criteria"
   */
  displayNoStoreFound(allStoresHidden: boolean) {
    if (allStoresHidden) {
      const sliderBody = STORELOCATORCOMPONENT.sidebarHtmlElement.querySelector('cwc-sidebar-body');
      const newcontent = document.createElement('cwc-location');
      newcontent.setAttribute('id', 'no-store-found');
      newcontent.innerHTML =
        '<div class="info-content"><p>' + TextResources.resources['filter'].not_found_slider + '</p></div>';
      sliderBody.appendChild(newcontent);
    } else {
      const unfoundResultsMessage = STORELOCATORCOMPONENT.sidebarHtmlElement.querySelector('#no-store-found');
      if (unfoundResultsMessage) {
        unfoundResultsMessage.remove();
      }
    }
  }

  resetButtonEvent() {
    const resetButton = this.filterHTMLElement.querySelector('#btn-reset-filters');

    resetButton.addEventListener('click', () => {
      for (let i = 0; i < this.filterElems.length; i++) {
        const productSelector = this.filterElems[i] as HTMLInputElement;

        if (productSelector.checked) {
          productSelector.click();
        }
      }
    });
  }

  resetFilter() {
    const filterAccordion = this.filterHTMLElement.querySelector('.accordion.active') as HTMLElement;
    const filterElems = this.filterElems;

    if (filterElems.length > 0) {
      for (let i = 0; i < filterElems.length; i++) {
        const productSelector = filterElems[i] as HTMLInputElement;

        if (productSelector.checked) {
          productSelector.click();
        }
      }
    }
    if (filterAccordion) {
      filterAccordion.click();
    }
  }

  getFilterProductsTemplate(locationProducts) {
    let output = '';
    let filterItems = [];

    if (ConfigData.data['currentFilter'] && ConfigData.data['currentFilter'] !== 'none') {
      const prodString = ConfigData.data['currentFilter'].replaceAll(' ', '');
      const prodArray = prodString.split(',');
      filterItems = prodArray;
    } else {
      filterItems = locationProducts;
    }

    for (let i = 0; i < filterItems.length; i++) {
      const prodId = filterItems[i].replaceAll('_', '-');
      const prodItemName = filterItems[i].substring(5); /* eslint-disable-line no-magic-numbers */
      const prodLabel = TextResources.resources['productData'][prodItemName].headline;
      let secondClass = '';

      if (i === 0) {
        secondClass = ' first';
      }
      if (i === filterItems.length - 1) {
        secondClass = ' last';
      }

      output += TEMPLATE.getFilterProductTemplate(secondClass, prodId, prodLabel);
    }
    return output;
  }
}

export const FILTER = new FilterService();
